import React, { useState } from 'react';
import {decodeToken} from 'react-jwt';
import { useNavigate } from "react-router-dom";

import "./Login.css";
import axios from "axios";


const Login = () => {
    const navigate = useNavigate()
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            axios.post('http://localhost:8888/auth/login', JSON.stringify({ username, password }), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                if (response.status === 200) {
                    const token = response.data.token;
                    const decoded = decodeToken(token);

                    // Store the token in local storage
                    localStorage.setItem('token', token);
                    // Redirect the user to the dashboard
                    navigate('/dashboard');
                }
            }).catch((err) => {
                console.log(err);
            })


        } catch (error) {
            console.log(error);
        }

        setIsLoading(false);
    };

    return (
        <div className="login-container">
            <h1>Login</h1>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={username}
                        onChange={(event) => setUsername(event.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                    />
                </div>
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Loading...' : 'Login'}
                </button>
            </form>
        </div>
    );
};

export default Login;
